'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { useEffect, useState } from 'react';
import { Row, Col, Container } from 'reactstrap';
import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
  EmailIcon,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
} from 'react-share';
import ContentSection from 'shared/components/ContentSection';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import dayjs from '../../utils/dayjs';
import axios from 'axios';
import BlogpostTeaser from './BlogpostTeaser';
import ArticleContainer from '../ArticleContainer';
import ContentRow from '../ContentRow';
import { Dictionaries, Locale } from '../../i18n/i18n-config';

type Props = {
  locale: Locale;
  dictionary: Partial<Dictionaries>;
  post: any;
  latestBlogPosts: any;
  path?: string;
};
function Post({ locale, dictionary, post, latestBlogPosts, path }: Props) {
  const { formatMessage } = getI18nUtils(dictionary);
  const { created, category, author, headerImg, title, intro, body, uri } = post;
  const [showAuthor, setShowAuthor] = useState<boolean>(false);
  const shareURL = `https://www.${process.env.NEXT_PUBLIC_APP}/${locale}${uri}`;

  useEffect(() => {
    axios
      .get(`/blogposts/authors/${author.id}.png`)
      .then((res) => {
        const contentType = res.headers['content-type'];
        if (contentType === 'image/png') setShowAuthor(true);
      })
      .catch(() => setShowAuthor(false));
  }, []);

  return (
    <>
      <article className={category}>
        <ArticleContainer id="blogTitle">
          <Container>
            <Row>
              <Col>
                <span className={`category ${category}`}>{formatMessage({ id: category.trim().toLowerCase() })}</span>
                <h1>{title}</h1>
              </Col>
            </Row>
            <Row>
              <Col md="8" className="author">
                {showAuthor && <img className="rounded-circle" src={`/blogposts/authors/${author.id}.png`} alt={author.name} />}
                <div>
                  <span className="name">{author.name}</span>
                  <span className="published text-muted">{dayjs(created).format('DD MMMM YYYY')}</span>
                </div>
              </Col>
              <Col md="4" className="d-flex justify-content-end">
                <FacebookShareButton url={shareURL}>
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <WhatsappShareButton url={shareURL} title={title} className="ms-2">
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>
                <LinkedinShareButton
                  className="ms-2"
                  title={title}
                  summary={formatMessage({ id: 'SEO-description-job' }, { jobTitle: title })}
                  // source={uri}
                  url={shareURL}
                >
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>
                <EmailShareButton url={shareURL} className="ms-2" subject={title}>
                  <EmailIcon size={32} round />
                </EmailShareButton>
              </Col>
            </Row>
            <Row className="my-3">
              {headerImg?.wide?.medium && (
                <img
                  id="blogHeaderImg"
                  className="img-fluid img img-responsive lpImage"
                  src={`${headerImg.wide.medium}`}
                  srcSet={`${headerImg.wide.medium} 1x, ${headerImg.wide.large} 2x`}
                  alt={headerImg.description}
                />
              )}
            </Row>
            <Row>
              <Col className="intro mt-2 mb-2">{intro && <section>{intro}</section>}</Col>
            </Row>
            <Row>
              <ContentRow>
                {body.map((section, index) => (
                  <ContentSection
                    dictionary={dictionary}
                    key={`section-${index}`}
                    source="blogPost"
                    id={post.id}
                    section={section}
                    className="pt-4 pb-4 postBody"
                  />
                ))}
              </ContentRow>
            </Row>
            <Row>
              <Col xs="8" />
              <Col xs="4" className="d-flex justify-content-end">
                <FacebookShareButton url={shareURL}>
                  <FacebookIcon size={32} round />
                </FacebookShareButton>
                <WhatsappShareButton url={shareURL} title={title} className="ms-2">
                  <WhatsappIcon size={32} round />
                </WhatsappShareButton>
                <LinkedinShareButton
                  className="ms-2"
                  title={title}
                  summary={formatMessage({ id: 'SEO-description-job' }, { jobTitle: title })}
                  // source={uri}
                  url={shareURL}
                >
                  <LinkedinIcon size={32} round />
                </LinkedinShareButton>
                <EmailShareButton url={shareURL} className="ms-2" subject={title}>
                  <EmailIcon size={32} round />
                </EmailShareButton>
              </Col>
            </Row>
          </Container>
        </ArticleContainer>
      </article>
      <div className="bg-light pt-5 pb-5">
        <Container>
          <Row>
            <Col>
              <h2 className="text-center text-md-start mb-4">
                <span>{formatMessage({ id: 'post-other-post' })}</span>
              </h2>
            </Col>
          </Row>

          <Row>
            {latestBlogPosts &&
              latestBlogPosts.map((latestPost) => (
                <Col xs="12" lg="4" key={latestPost.id}>
                  <BlogpostTeaser dictionary={dictionary} post={latestPost} path={path} />
                </Col>
              ))}
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Post;
